import { Box, Typography } from "@material-ui/core"
import { Dispatch, FunctionComponent, SetStateAction, useRef } from "react"
import { OnboardingQuestion, BackendPartner } from "common/types"
import { useNotification } from "hooks/use-notification/useNotification"
import { useScreenSizes } from "hooks/use-screen-sizes/useScreenSizes"
import { Button } from 'common/atoms/Button/Button'

interface BannerProps {
  handleChange: Function
  getProcessedFile: Function
  questionIndex: number
  editProfileQuestions: OnboardingQuestion[]
  setProfileQuestions: Function
  company: BackendPartner
  fileName: string
  setFileName: Dispatch<SetStateAction<string>>
  previewImage: string
  setPreviewImage: Function
  avatarUpdated?: boolean
  setAvatarUpdated?: Function
}

export const AddBanner: FunctionComponent<BannerProps> = ({
  company,
  handleChange,
  getProcessedFile,
  questionIndex,
  editProfileQuestions,
  setProfileQuestions,
  setFileName,
  previewImage,
  setPreviewImage,
  setAvatarUpdated
}) => {

  const hiddenFileInput = useRef(null)
  const { notify } = useNotification()
  const { isDevice } = useScreenSizes()
  const aws = process.env.REACT_APP_AWS_BUCKET_NAME as string

  const handleUpload = (e: any) => {
    const maxImageFileSize = 5
    const files = e.target.files
    const fsMb = files[0]?.size / (1024 * 1024);
    if (fsMb > maxImageFileSize) {
      notify('error', 'Upload limit for an image is 5MB');
      e.target.value = ''
      setPreviewImage(company?.banner)
      setAvatarUpdated(false)
      setFileName('')
      return false
    }
    getProcessedFile(files, ['jpeg', 'jpg', 'png'], 'stream', async ({ file }: any) => {
      const logo = editProfileQuestions.find(x => x.question.includes('Banner'))
      const fileNameArray = files[0]?.name?.toLowerCase()?.split('.')
      if (logo) {
        logo.userAnswer = JSON.stringify({ file: file, type: fileNameArray[fileNameArray.length - 1] })
        editProfileQuestions[editProfileQuestions.indexOf(logo)] = logo
        setProfileQuestions([...editProfileQuestions])
      }
      setPreviewImage(URL.createObjectURL(e.target.files[0]))
      setFileName(files[0]?.name)
      setAvatarUpdated(true)
      e.target.value = ''
    })
  }
  const banner = editProfileQuestions.find(x => x.question.includes('Banner'))

  const clearAvatar = (e) => {
    banner.userAnswer = ''
    setPreviewImage(`https://${aws}.s3.amazonaws.com/media/images/company_profile_banner.png`)
    editProfileQuestions[editProfileQuestions.indexOf(banner)] = banner
    setProfileQuestions([...editProfileQuestions])
    e.target.value=''
  }
  
  return (
    <>
      <Box paddingBottom="4em">
      <Typography variant="caption">
          <Box fontWeight="bold" display="flex" justifyContent="right">
            Banner Dimension: 1052 x 163
          </Box>
        </Typography>
        <Box 
          height={ isDevice ? "6em" : "10em"} 
          width="100%">
          <img
            src={previewImage || company?.banner || '/assets/backgrounds/company_profile_banner.png'}
            alt="company banner"
            width="100%"
            height="100%"
            object-fit="contain"
          />
        </Box>
        <Box position="relative" bottom="0.2em" left={isDevice ? "75%" : "80%"} display="flex" flexDirection="column" justifyContent="center" alignItems="flex-end" width={isDevice ? "25%" : "20%"}>
          <Box height="2rem" display="flex" justifyContent="right" alignItems="center" width="100%">
            <Button
              design="tertiary"
              small
              onClick={
                e => {
                  hiddenFileInput.current.click()
                }
              }
            >
              <input
                onChange={e => {
                  handleUpload(e)
                  handleChange(questionIndex, e)
                }}
                id="actual-btn"
                type="file"
                ref={hiddenFileInput}
                hidden
              />
              <Typography variant="caption">Add Banner</Typography>
            </Button>
          </Box>
          {banner?.userAnswer != '' && (
            <Box height="2rem" display="flex" justifyContent="right" alignItems="center" width="100%" mt={isDevice ? "-0.6rem" : "-0.2rem"}>
              <Button
                design="tertiary"
                small
                onClick={
                  e => {
                    clearAvatar(e)
                    handleChange(questionIndex, e)
                  }
                }
              >
                <Typography variant="caption" style={{ whiteSpace: 'nowrap' }}>Remove Banner</Typography>
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </>
  )
}